import { gql } from "@apollo/client";

export const INSURERS_QUERY = gql`
  query insurers($insuranceTypeId: Int!) {
    insurers(insuranceTypeId: $insuranceTypeId) {
      id
      chPartnerId
      name
    }
  }
`;

export const INSURED_PERIODS_QUERY = gql`
  query periodRange($insuranceTypeCode: String!) {
    periodRange(insuranceTypeCode: $insuranceTypeCode) {
      min
      max
    }
  }
`;

export const MONTH_NO_VALUES_QUERY = gql`
  query monthNoValues($insuranceTypeCode: String!) {
    monthNoValues(insuranceTypeCode: $insuranceTypeCode)
  }
`;
